import countries from "@/utils/countries";

/** **************** */
/** **************** */
/* PRIVATE FUNCTIONS */
/** **************** */
/** **************** */

function simplifyLocale(locale) {
  if (!locale) return null;
  return locale.split("-")[0].toLowerCase();
}

export const countryOptions = (locale = "ca-ES") => {
  switch (simplifyLocale(locale)) {
    case "de":
      return countries.map(c => ({
        label: c.name_de,
        value: c.code,
        countryCode: c.code,
        dialCode: c.dial_code
      }));
    case "en":
      return countries.map(c => ({
        label: c.name_en,
        value: c.code,
        countryCode: c.code,
        dialCode: c.dial_code
      }));
    case "es":
      return countries.map(c => ({
        label: c.name_es,
        value: c.code,
        countryCode: c.code,
        dialCode: c.dial_code
      }));
    case "ca":
      return countries.map(c => ({
        label: c.name_ca,
        value: c.code,
        countryCode: c.code,
        dialCode: c.dial_code
      }));
    default:
      return countries.map(c => ({
        label: c.name_en,
        value: c.code,
        countryCode: c.code,
        dialCode: c.dial_code
      }));
  }
};

export const countryOptionsAlpha3 = (locale = "ca-ES") => {
  switch (simplifyLocale(locale)) {
    case "de":
      return countries.map(c => ({
        label: c.name_de,
        value: c.code_alpha_3,
        countryCode: c.code_alpha_3,
        dialCode: c.dial_code
      }));
    case "en":
      return countries.map(c => ({
        label: c.name_en,
        value: c.code_alpha_3,
        countryCode: c.code_alpha_3,
        dialCode: c.dial_code
      }));
    case "es":
      return countries.map(c => ({
        label: c.name_es,
        value: c.code_alpha_3,
        countryCode: c.code_alpha_3,
        dialCode: c.dial_code
      }));
    case "ca":
      return countries.map(c => ({
        label: c.name_ca,
        value: c.code_alpha_3,
        countryCode: c.code_alpha_3,
        dialCode: c.dial_code
      }));
    default:
      return countries.map(c => ({
        label: c.name_en,
        value: c.code_alpha_3,
        countryCode: c.code_alpha_3,
        dialCode: c.dial_code
      }));
  }
};

export const languageOptions = [
  { label: "Català", value: "ca" },
  { label: "Deutch", value: "de" },
  { label: "Español", value: "es" },
  { label: "English", value: "en" },
  { label: "Français", value: "fr" },
  { label: "Italiano", value: "it" },
  { label: "Pусский", value: "ru" },
  { label: "Altre", value: "other" }
];

export const genderOptions = (locale = "ca-ES") => {
  switch (simplifyLocale(locale)) {
    case "de":
      return [
        { label: "Mann", value: "MALE" },
        { label: "Frau", value: "FEMALE" },
        { label: "Andere", value: "OTHER" }
      ];
    case "en":
      return [
        { label: "Man", value: "MALE" },
        { label: "Woman", value: "FEMALE" },
        { label: "Other", value: "OTHER" }
      ];
    case "es":
      return [
        { label: "Hombre", value: "MALE" },
        { label: "Mujer", value: "FEMALE" },
        { label: "Otro", value: "OTHER" }
      ];
    case "ca":
      return [
        { label: "Home", value: "MALE" },
        { label: "Done", value: "FEMALE" },
        { label: "Altre", value: "OTHER" }
      ];
    default:
      return [
        { label: "Man", value: "MALE" },
        { label: "Woman", value: "FEMALE" },
        { label: "Other", value: "OTHER" }
      ];
  }
};

export const idTypeOptions = (locale = "ca-ES") => {
  switch (simplifyLocale(locale)) {
    case "de":
      return [
        { label: "Reisepass", value: "PASSPORT" },
        { label: "NIF (Spanien)", value: "NIF" },
        { label: "NIE (Spanien)", value: "NIE" },
        { label: "CIF (Spanien)", value: "CIF" },
        { label: "Andere (ausländischer DNI, Führerschein, etc.)", value: "OTHER" },
      ];
    case "en":
      return [
        { label: "Passport", value: "PASSPORT" },
        { label: "NIF (Spanish)", value: "NIF" },
        { label: "NIE (Spanish)", value: "NIE" },
        { label: "CIF (Spanish)", value: "CIF" },
        { label: "Other (foreign national ID, driver's license, etc.)", value: "OTHER" },
      ];
    case "es":
      return [
        { label: "Pasaporte", value: "PASSPORT" },
        { label: "NIF (DNI Español)", value: "NIF" },
        { label: "NIE (Número de Identidad de Extranjero)", value: "NIE" },
        { label: "CIF (Español)", value: "CIF" },
        { label: "Otro (DNI extranjero, carnet de conducir, etc.)", value: "OTHER" },
      ];
    case "ca":
      return [
        { label: "Passaport", value: "PASSPORT" },
        { label: "NIF (DNI Espanyol)", value: "NIF" },
        { label: "NIE (Número d'Identificació d'Extranger)", value: "NIE" },
        { label: "CIF (Espanyol)", value: "CIF" },
        { label: "Altre (DNI extranger, carnet de conduir, etc.)", value: "OTHER" },
      ];
    default:
      return [
        { label: "Passport", value: "PASSPORT" },
        { label: "NIF (Spanish Identification Number)", value: "NIF" },
        { label: "NIE (Spanish Foreigners Identification Number)", value: "NIE" },
        { label: "CIF (Spanish)", value: "CIF" },
        { label: "Other (foreign national ID, driver's license, etc.)", value: "OTHER" },
      ];
  }
};

export const transportMethodOptions = (locale = "ca-ES") => {
  switch (simplifyLocale(locale)) {
    case "de":
      return [
        { label: "Flugzeug", value: "PLANE" },
        { label: "Fähre", value: "BOAT" },
        { label: "Kein Transport", value: "NONE" }
      ];
    case "en":
      return [
        { label: "Plane", value: "PLANE" },
        { label: "Ferry", value: "BOAT" },
        { label: "No transport", value: "NONE" }
      ];
    case "es":
      return [
        { label: "Avión", value: "PLANE" },
        { label: "Barco", value: "BOAT" },
        { label: "Sin transporte", value: "NONE" }
      ];
    case "ca":
      return [
        { label: "Avió", value: "PLANE" },
        { label: "Vaixell", value: "BOAT" },
        { label: "Sense transport", value: "NONE" }
      ];
    default:
      return [
        { label: "Plane", value: "PLANE" },
        { label: "Ferry", value: "BOAT" },
        { label: "No transport", value: "NONE" }
      ];
  }
};

export const parentageTypeOptions = (locale = "ca-ES") => {
  switch (simplifyLocale(locale)) {
    case "de":
      return [
        { label: "Mutter/Vater", value: "PM" },
        { label: "Bruder/Schwester", value: "HR" },
        { label: "Onkel/Tante", value: "TI" },
        { label: "Großvater/Großmutter", value: "AB" },
        { label: "Urgroßvater/Urgroßmutter", value: "BA" },
        { label: "Vormund", value: "TU" },
        { label: "Andere", value: "OT" },
      ];
    case "en":
      return [
        { label: "Mother/Father", value: "PM" },
        { label: "Brother/Sister", value: "HR" },
        { label: "Uncle/Aunt", value: "TI" },
        { label: "Grandfather/Grandmother", value: "AB" },
        { label: "Great-grandfather/Great-grandmother", value: "BA" },
        { label: "Guardian", value: "TU" },
        { label: "Others", value: "OT" },
      ];
    case "es":
      return [
        { label: "Madre/Padre", value: "PM" },
        { label: "Hermano/Hermana", value: "HR" },
        { label: "Tío/Tía", value: "TI" },
        { label: "Abuelo/Abuela", value: "AB" },
        { label: "Bisabuelo/Bisabuela", value: "BA" },
        { label: "Tutor/a", value: "TU" },
        { label: "Otros", value: "OT" },
      ];
    case "ca":
      return [
        { label: "Mare/pare", value: "PM" },
        { label: "Germà/germana", value: "HR" },
        { label: "Oncle/tia", value: "TI" },
        { label: "Avi/àvia", value: "AB" },
        { label: "Besavi/besàvia", value: "BA" },
        { label: "Tutor/a", value: "TU" },
        { label: "Altres", value: "OT" },
      ];
    default:
      return [
        { label: "Mother/Father", value: "PM" },
        { label: "Brother/Sister", value: "HR" },
        { label: "Uncle/Aunt", value: "TI" },
        { label: "Grandfather/Grandmother", value: "AB" },
        { label: "Great-grandfather/Great-grandmother", value: "BA" },
        { label: "Guardian", value: "TU" },
        { label: "Others", value: "OT" },
      ];
  }
};
